import Box from '@mui/material/Box';
import ToggleButton from '@mui/material/ToggleButton';
import Typography from '@mui/material/Typography';
import { ToggleButtonGroupField } from '@openx/components-core/lib/ToggleButtonGroupField/ToggleButtonGroupField';
import { useTranslation } from 'react-i18next';

export type DateResolution = 'daily' | 'weekly' | 'monthly';

export const DATE_RESOLUTION_LABELS: Record<DateResolution, string> = {
  daily: 'Day',
  weekly: 'Week',
  monthly: 'Month',
};

export interface DateResolutionToggleProps {
  value: DateResolution;
  onChange: (resolution: DateResolution) => void;
  disabled?: boolean;
}

export const DateResolutionToggle = ({ value, onChange, disabled = false }: DateResolutionToggleProps) => {
  const { t } = useTranslation();

  const options: { value: DateResolution; label: string }[] = [
    { value: 'daily', label: t(DATE_RESOLUTION_LABELS.daily) },
    { value: 'weekly', label: t(DATE_RESOLUTION_LABELS.weekly) },
    { value: 'monthly', label: t(DATE_RESOLUTION_LABELS.monthly) },
  ];

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Typography variant="body2" sx={{ mr: 2, color: 'text.secondary' }}>
        {t('View by:')}
      </Typography>
      <ToggleButtonGroupField<DateResolution>
        onValueToggle={onChange}
        value={value}
        enforceSelection
        exclusive
        disabled={disabled}
        data-test={'date-resolution-toggle'}
      >
        {options.map(option => (
          <ToggleButton
            key={option.value}
            value={option.value}
            sx={{ textTransform: 'uppercase', fontSize: '12px' }}
            data-test={`date-resolution-${option.value}`}
          >
            {option.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroupField>
    </Box>
  );
};
